
import React from 'react';
import StatsCard from '../card/StatsCard';
import { DollarSign, Droplets, Server, Building2 } from 'lucide-react';

interface WaterCardsProps {
  isEditMode: boolean;
}

const WaterCards: React.FC<WaterCardsProps> = ({ isEditMode }) => {
  return (
    <>
      <StatsCard
        id="water-cost"
        title="Total Water Cost"
        value="$900"
        change="9.8% vs last month"
        isIncreasing={true}
        icon={<DollarSign className="h-6 w-6 text-blue-600" />}
        bgClass="bg-blue-50 dark:bg-blue-900/20"
        delay={400}
        isEditMode={isEditMode}
      />
      
      <StatsCard
        id="water-consumption"
        title="Water Consumption"
        value="450 m³"
        change="9.7% vs last month"
        isIncreasing={true}
        icon={<Droplets className="h-6 w-6 text-blue-600" />}
        bgClass="bg-blue-50 dark:bg-blue-900/20"
        delay={500}
        isEditMode={isEditMode}
      />
      
      <StatsCard
        id="water-devices"
        title="Water Devices"
        value="90"
        change="3.4% vs last month"
        isIncreasing={true}
        icon={<Server className="h-6 w-6 text-blue-600" />}
        bgClass="bg-blue-50 dark:bg-blue-900/20"
        delay={600}
        isEditMode={isEditMode}
      />
      
      <StatsCard
        id="water-cost-facility"
        title="Water Cost/Facility"
        value="$90"
        change="9.8% vs last month"
        isIncreasing={true}
        icon={<Building2 className="h-6 w-6 text-blue-600" />}
        bgClass="bg-blue-50 dark:bg-blue-900/20"
        delay={700}
        isEditMode={isEditMode}
      />
    </>
  );
};

export default WaterCards;
